// @ts-nocheck
import React, { lazy } from 'react';
import { Dialog, DialogSuspense, FormattedMessage as T } from '@/components';

import withDialogRedux from '@/components/DialogReduxConnect';
import { compose } from '@/utils';
import '@/style/containers/CatalogDialog/style.scss';

const CatalogDialogContent = lazy(() =>
  import('./CatalogDialogContent'),
);

// Edit item dialog for editing item, variants, charges and decoration
function CatalogDialog({
  dialogName,
  payload = { id: null },
  isOpen,
}) {
  return (
    <Dialog
      name={dialogName}
      title="Add Item"
      className={'dialog--catalog'}
      isOpen={isOpen}
      autoFocus={true}
      canEscapeKeyClose={true}
      style={{ margin: 0, paddingBottom: 0 }}
    >
      <DialogSuspense>
        <CatalogDialogContent
          dialogName={dialogName}
          itemId={payload.id}
          onConfirm={payload.onConfirm}
        />
      </DialogSuspense>
    </Dialog>
  );
}

export default compose(withDialogRedux())(CatalogDialog);
